import { createContext, } from 'react';
import { optionType, shapes, sizes, } from './constants';
export const defaultContext = {
    isLoading: undefined,
    name: undefined,
    onChange: () => { },
    optionType: optionType.radio,
    selectedSwatches: '',
    shape: shapes.CIRCLE,
    size: sizes.medium,
};
export const SwatchPickerContext = createContext(defaultContext);
